import React from "react";
import { withRouter } from "react-router-dom";
import ServiceItem from "../create_project/serviceItem";
import ServiceSubservices from "../create_project/service_subservices";
import checkmarkCreateProject from "../../../../assets/images/checkmarkCreateProject.svg";
import LogoSpinner from "../../../../assets/images/landing/video-thumbnails/MA-logo-spinner.gif";
import BundleGroup from "./bundle_group"
import debounce from 'debounce'
import {GuestServiceChoices, guestGuide} from '../create_project_home_page/GuestBookingGuide';

class ServicesSelectionComponent2 extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      errors: [],
      updated_service: false,
      minimize: this.props.minimize
    }

    this.handler = this.handler.bind(this)
    this.toggleSelected = this.toggleSelected.bind(this)
    this.removeService = this.removeService.bind(this)
    this.debouceScrollTo = debounce((selector) => this.scrollTo(selector), 200)
    this.servicesListRef = React.createRef()
  }

  scrollTo(selector) {
    const element = document.querySelector(selector)
    if (element) element.scrollIntoView()
  }

  handler(newState) {
    if (newState.errors) {
      this.setState(newState)
    } else {
      this.setState({ errors: [] })
      this.props.changeParentState(newState)
    }
  }

  isDesktop() {
    return window.matchMedia('(min-width: 751px)').matches
  }

  toggleSelected(sub_service, service) {
    let newState = Object.assign({}, this.props.package_attributes);
    let newStateSubservices = Object.assign({}, this.props.selectedSubservices);
    let newStateAppointments = Object.assign({}, this.props.appointments);
    let newStatePreviouslyChosen = Object.assign({}, this.props.newStatePreviouslyChosen);
    let newStateVisitedServices = Object.assign({}, this.props.visitedServices)
    let newStateVisitedAppointments = Object.assign({}, this.props.visitedAppointments)
    let removed = false

    if (this.props.package_attributes[sub_service.service_id]) {
      if (newState[sub_service.service_id]["package_sub_services_attributes"]) {
        if (newState[sub_service.service_id]["package_sub_services_attributes"][sub_service.id]) {
          removed = true
          delete newState[sub_service.service_id]["package_sub_services_attributes"][sub_service.id]
          delete newStateSubservices[sub_service.id]
          if (Object.values(newState[sub_service.service_id]["package_sub_services_attributes"]).length === 0) {
            delete newStateAppointments[sub_service.service_id]
            delete newState[sub_service.service_id]
            if (newStatePreviouslyChosen[sub_service.service_id]) {
              delete newStatePreviouslyChosen[sub_service.service_id]
            }
            if (newStateVisitedServices[sub_service.service_id]){
              delete newStateVisitedServices[sub_service.service_id]
            }

            if (newStateVisitedAppointments[sub_service.service_id]){
              delete newStateVisitedAppointments[sub_service.service_id]
            }
          }
        } else {
          if (!this.props.addonServices && service.one_option_allowed) {
            service?.subServices.forEach((sub_service) => {
              if (this.props.selectedSubservices[sub_service.id]) {
                delete newStateSubservices[sub_service.id]
                delete newState[sub_service.service_id]["package_sub_services_attributes"][sub_service.id]
              }
            })
          }
          newState[sub_service.service_id]["package_sub_services_attributes"][sub_service.id] = { sub_service_id: sub_service.id }
          newStateSubservices[sub_service.id] = sub_service
        }
      } else {
        newState[sub_service.service_id]["package_sub_services_attributes"] = { [sub_service.id]: { sub_service_id: sub_service.id } }
        newStateSubservices[sub_service.id] = sub_service
      }
    } else {
      newState[sub_service.service_id] = { package_sub_services_attributes: { [sub_service.id]: { sub_service_id: sub_service.id } } }
      newStateSubservices[sub_service.id] = sub_service
    }

    if (!this.props.addonServices && service.one_option_allowed && !removed && !this.props.upgradingPackage) {
      this.props.changeParentState({
        package_attributes: newState, selectedSubservices: newStateSubservices, appointments: newStateAppointments, previouslyChosen: newStatePreviouslyChosen, visitedServices: newStateVisitedServices, visitedAppointments: newStateVisitedAppointments, selected_service: -1, currentlySelectedService: null, addMoreModal: null
      })
    } else {
      this.props.changeParentState({
        package_attributes: newState, selectedSubservices: newStateSubservices, appointments: newStateAppointments, previouslyChosen: newStatePreviouslyChosen, visitedServices: newStateVisitedServices, visitedAppointments: newStateVisitedAppointments
      })
    }
  }

  removeService(service){
    let newState = Object.assign({}, this.props.package_attributes);
    let newStateSubservices = Object.assign({}, this.props.selectedSubservices);
    let newStateAppointments = Object.assign({}, this.props.appointments);
    let newStatePreviouslyChosen = Object.assign({}, this.props.newStatePreviouslyChosen);
    let newStateVisitedServices = Object.assign({}, this.props.visitedServices)
    let newStateVisitedAppointments = Object.assign({}, this.props.visitedAppointments)

    Object.keys(
      this.props.package_attributes[service.id].package_sub_services_attributes
    ).forEach(subServiceId => {
      delete newState[service.id]["package_sub_services_attributes"][subServiceId]
      delete newStateSubservices[subServiceId]
      if (Object.values(newState[service.id]["package_sub_services_attributes"]).length === 0) {
        delete newStateAppointments[service.id]
        delete newState[service.id]
        if (newStatePreviouslyChosen[service.id]) {
          delete newStatePreviouslyChosen[service.id]
        }
        if (newStateVisitedServices[service.id]) {
          delete newStateVisitedServices[service.id]
        }

        if (newStateVisitedAppointments[service.id]) {
          delete newStateVisitedAppointments[service.id]
        }
      }
    })
    this.props.changeParentState({
      package_attributes: newState, selectedSubservices: newStateSubservices, appointments: newStateAppointments, previouslyChosen: newStatePreviouslyChosen, visitedServices: newStateVisitedServices, visitedAppointments: newStateVisitedAppointments
    })
  }

  render() {
    const selectedService = this.props.services[this.props.selected_service]
    let minimizeId = ""
    let minimized = ""
    let checkmark = ""
    const allErrors = [...this.state.errors, ...this.props.summaryErrors]

    const selectedSubServices = Object.values(this.props.selectedSubservices)
    const selectedSubServicesByService = selectedSubServices.reduce((res, subService) => {
      if (res[subService.service_id]) {
        res[subService.service_id].push(subService)
      } else {
        res[subService.service_id] = [subService]
      }
      return res
    }, {})

    let sleek_bundle_component = <div></div>

    // if (this.props.new_order_process){
    //   const DISCOUNT_TIERS = [
    //     { label: `2 Services ${this.props.bundleDiscountWith2}%`, count: 2 },
    //     { label: `3 Services ${this.props.bundleDiscountWith3}%`, count: 3 },
    //     { label: `4+ Services ${this.props.bundleDiscountWith4}%`, count: 4 },
    //   ];

    //   let activeCount = this.props.selectedEligibleSubServices.length

    //   if (this.props.selectedEligibleSubServices.length != Object.values(this.props.selectedSubservices || []).length){
    //     activeCount = 0
    //   }

    //   sleek_bundle_component = <div className="discount-container">
    //     <div className="discount-bar">
    //       {DISCOUNT_TIERS.map((tier) => (
    //         <div key={tier.count} className="discount-tier" id={activeCount === tier.count ? "selectedTier" : ""}>
    //           <span className="icon">
    //             {activeCount === tier.count ? "✅" : "☑️"}
    //           </span>
    //           <span className="label">{tier.label}</span>
    //         </div>
    //       ))}
    //     </div>
    //   </div>
    // }

    if (!this.props.bundleSelected){
      let servicesLis = []
      if (this.props.services) {
        if (this.props.specific_service !== -1) {
          servicesLis = Object.values(this.props.services || []).filter(service => service.id === this.props.specific_service).sort(function (a, b) { return a.sort_order - b.sort_order }).map((service) => <ServiceItem homepage={this.props.homepage} new_update_process={this.props.new_update_process} new_order_process={this.props.new_order_process} toggleSelected={this.toggleSelected} removeService={this.removeService} location_pricing={this.props.location_pricing} key={service.id} scrollTo={this.debouceScrollTo} selectedSubservices={selectedSubServicesByService[service.id]} zipcode={this.props.zipcode} service={service} changeParentState={this.handler} selected={this.props.selected_service === service.id} cancelled={this.props.cancelledPackages[service.id] && this.props.package_attributes[service.id] && !this.props.package_attributes[service.id]["appointment_time"]} previouslySelected={this.props.package_attributes[service.id] && Object.values(this.props.package_attributes[service.id]["package_sub_services_attributes"] || {}).length > 0} />)
        } else {
          if (this.props.previous_services){
            let previous_services = {}
            let previous_services_multi = {}
            if (this.props.currentUser.roles.admin){
              this.props.previous_services.forEach(service => {
                if (this.props.services[service.id]?.one_option_allowed) {
                  previous_services[service.id] = true
                } else {
                  previous_services_multi[service.id] = true
                }
              })
            } else {
              this.props.previous_services.forEach(service => previous_services[service.id] = true)
            }
            servicesLis = Object.values(this.props.services || []).filter(service => service.subServices.filter(sub_service => this.props.addonServices ? sub_service.addon : !sub_service.addon).length > 0 && !previous_services[service.id]).sort(function (a, b) { return a.sort_order - b.sort_order }).map((service) => <ServiceItem new_update_process={this.props.new_update_process} location_pricing={this.props.location_pricing} key={service.id} scrollTo={this.debouceScrollTo} selectedSubservices={previous_services_multi[service.id] ? [] : selectedSubServicesByService[service.id]} zipcode={this.props.zipcode} service={service} changeParentState={this.handler} selected={this.props.selected_service === service.id} cancelled={this.props.cancelledPackages[service.id] && this.props.package_attributes[service.id] && !this.props.package_attributes[service.id]["appointment_time"]} previouslySelected={previous_services_multi[service.id] ? false : (this.props.package_attributes[service.id] && Object.values(this.props.package_attributes[service.id]["package_sub_services_attributes"] || {}).length > 0)} />)
          } else {
            servicesLis = Object.values(this.props.services || []).filter(service => service.subServices.filter(sub_service => this.props.addonServices ? sub_service.addon : !sub_service.addon).length > 0).sort(function (a, b) { return a.sort_order - b.sort_order }).map((service) => <ServiceItem new_update_process={this.props.new_update_process} new_order_process={this.props.new_order_process} homepage={this.props.homepage} toggleSelected={this.toggleSelected} removeService={this.removeService} location_pricing={this.props.location_pricing} key={service.id} scrollTo={this.debouceScrollTo} selectedSubservices={selectedSubServicesByService[service.id]} zipcode={this.props.zipcode} service={service} changeParentState={this.handler} selected={this.props.selected_service === service.id} cancelled={this.props.cancelledPackages[service.id] && this.props.package_attributes[service.id] && !this.props.package_attributes[service.id]["appointment_time"]} previouslySelected={this.props.package_attributes[service.id] && Object.values(this.props.package_attributes[service.id]["package_sub_services_attributes"] || {}).length > 0} />)
          }
        }
      }

      if (this.props.appointments[this.props.selected_service] && this.state.errors.length > 0) {
        this.setState({ errors: [] })
      }

      const isSubServiceSelection = !!this.props.currentlySelectedService

      if (this.props.inAppBooking && this.props.minimize && this.props.new_order_process) {
        return <div className="projectLocationComponent in-app-collapsed-step"><div className="settingsComponentHeading">Build your shoot</div></div>;
      }

      if ((this.props.guestBooking || (this.props.inAppBooking && !this.props.minimize)) && this.props.new_order_process) {
        const current=this.props.currentlySelectedService;
        return <div className="projectLocationComponent">
          <header className="modalHeader"><div className="settingsComponentHeading">{current ? `${{photography:'Photography',aerial:'Drone photography',floorplans:'Floor plan',video:'Video',twilight:'Twilight', 'virtual-tour':'Virtual tour'}[current.slug] || guestGuide(current).name} package` : 'Build your shoot'}</div>
            {this.props.coupon?.id && <div className="couponAppliedBadge">{this.props.coupon.percentage ? `${this.props.coupon.amount}% offer active` : `$${this.props.coupon.amount} offer active`}</div>}
            {allErrors.length>0 && <div className="errorDiv" role="alert">{allErrors}</div>}
          </header>
          <div className="modalScrollableContent">
            {this.props.loading ? <div className="createProjectLogoSpinner" role="status"><img src={LogoSpinner} alt="Loading services" /></div> : current ? <ServiceSubservices guestBooking={this.props.guestBooking} inAppBooking={this.props.inAppBooking} currentUser={this.props.currentUser} selectedSubservices={this.props.selectedSubservices} appointments={this.props.appointments} package_services={this.props.package_attributes} active_service={current} location_pricing={this.props.location_pricing} previouslyChosen={this.props.previouslyChosen} visitedServices={this.props.visitedServices} subservices={current.subServices} homepage={true} new_order_process={true} changeParentState={this.handler} /> : <GuestServiceChoices {...this.props} toggleSelected={this.toggleSelected} removeService={this.removeService} />}
          </div>
        </div>;
      }

      if (this.state.minimize) {
        minimizeId = "hidePropertyInputs"
        minimized = "projectHeadingMinmizedView"

        if (this.props.page && this.props.page > 2) {
          checkmark = "createProjectCheckmarkShow"
        }
      }

      if (servicesLis.length === 0 && this.props.loading === false) {
        servicesLis.push(<div className="unfortunateDiv"><div className="unfortunate">Unfortunately there are no more services to add for this project.</div></div>)
      } else if (this.props.loading === true) {
        servicesLis = <div className="createProjectLogoSpinner">
          <img className="logoImageSpinnerGif" src={LogoSpinner}></img>
        </div>
      }

      return (
        <div className="projectLocationComponent">
          <div className="modalHeader">
          <div className="projectLocationHeadingGrouping" id={minimized}>
            <div className="projectLocationHeadingMinimizedGrouping">
              <div className="createProjectCheckmark" id={checkmark}><img src={checkmarkCreateProject} /></div>
              <div className="settingsComponentHeading">
                  {isSubServiceSelection ? `${selectedService?.title} Packages` : this.props.new_order_process ? 'Build Your Shoot' : 'Choose Your Services'}
              </div>
              {this.props.coupon?.id && <div className="couponAppliedBadge">
                {this.props.coupon.percentage ? `${this.props.coupon.amount}% discount applied` : `$${this.props.coupon.amount} discount applied`}
              </div>}
            </div>
          </div>
          <div className="subServicesSubheading" id={minimizeId}>
            {/* {this.props.new_order_process ? selectedSubServices.length == 1 ? "Add another service to save 5%" : selectedSubServices.length == 2 ? "Add another service to save 10%" : selectedSubServices.length == 3 ? "Add another service to save 15%" : selectedSubServices.length > 3 ? "You have maximized your discount!" : "Add two or more services to increase your discount" : "Add services to fit your listing and budget."} */}
              {/* {this.props.new_order_process ? "The more services you bundle, the more you save!" : "Add services to fit your listing and budget."} */}
              {(isSubServiceSelection ? `Select any combination of services and bundle discounts apply automatically.` : `Select any combination of services and bundle discounts apply automatically.`)}
          </div>

          {/* <div className="subServicesHeadingBottomDivider" id={minimizeId} /> */}

          {allErrors.length > 0 && <div className="errorDiv mt-3 serviceSelectionErrors" id={minimizeId}>{allErrors}</div>}
          </div>

          <div className="modalScrollableContent">

          {!isSubServiceSelection ? <div style={{ position: "relative", display: "flex", flexDirection: "column", flex: 1, minHeight: 0 }}>
            <div className="servicesList" id={minimizeId} ref={this.servicesListRef}>
              <span
                id="scrollToHereNew"
                style={{
                  position: "absolute",
                  top: 0,
                  left: 0,
                  width: 0,
                  height: 0,
                  overflow: "hidden",
                  pointerEvents: "none",
                }}
              />
            {servicesLis}
            </div>

          </div> : <div id={minimizeId} style={{ display: "flex", flexDirection: "column", flex: 1, minHeight: 0 }}>
                <span
                  id="scrollToHereNew"
                  style={{
                    position: "absolute",
                    top: 0,
                    left: 0,
                    width: 0,
                    height: 0,
                    overflow: "hidden",
                    pointerEvents: "none",
                  }}
                />
            <ServiceSubservices currentUser={this.props.currentUser} selectedSubservices={this.props.selectedSubservices} appointments={this.props.appointments}
                                package_services={this.props.package_attributes}
                                active_service={this.props.currentlySelectedService}
                                addonServices={this.props.addonServices}
                                location_pricing={this.props.location_pricing}
                                previouslyChosen={this.props.previouslyChosen}
                                visitedServices={this.props.visitedServices}
                                subservices={this.props.currentlySelectedService?.subServices}
                                scrollTo={this.debouceScrollTo}
                                homepage={this.props.homepage}
                                new_order_process={this.props.new_order_process}
                                new_update_process={this.props.new_update_process}
                                previousSubservices={this.props.previousSubservices}
                                changeParentState={this.handler} />
          </div>}
          </div>
        </div>
      )
    } else {
      let bundleGroups = []

      if (!this.state.minimize){
        bundleGroups = this.props.bundle_groups.map(bundle_group => <BundleGroup changeParentState={this.handler} location_pricing={this.props.location_pricing} bundle_group={bundle_group} selected_bundle={this.props.selected_bundle} selectedSubservices={this.props.selectedSubservices} appointments={this.props.appointments} package_services={this.props.package_attributes} update_bundle={this.props.update_bundle} />)
      }

      if (this.state.minimize) {
        minimizeId = "hidePropertyInputs"
        minimized = "projectHeadingMinmizedView"

        if (this.props.page && this.props.page > 2) {
          checkmark = "createProjectCheckmarkShow"
        }
      }

      if (this.props.bundleLoading === true) {
        bundleGroups = <div className="createProjectLogoSpinner">
          <img className="logoImageSpinnerGif" src={LogoSpinner}></img>
        </div>
      }

      return (
        <div className="projectLocationComponent">
          <div className="projectLocationHeadingGrouping" id={minimized}>
            <div className="projectLocationHeadingMinimizedGrouping">
              <div className="createProjectCheckmark" id={checkmark}><img src={checkmarkCreateProject} /></div>
              <div className="settingsComponentHeading">Photography Packages</div>
            </div>
          </div>

          {/* <div className="subServicesHeadingBottomDivider" id={minimizeId} /> */}

          <div className="subServicesSubheading" id={minimizeId}>Choose the perfect set of services for showcasing your listing.</div>
          {allErrors.length > 0 && <div className="errorDiv mt-3 serviceSelectionErrors" id={minimizeId}>{allErrors}</div>}
          <div className="bundlesList" id={minimizeId}>
            {bundleGroups}
          </div>
        </div>
      )
    }
  }
}

export default withRouter(ServicesSelectionComponent2);
